import styled from 'styled-components';

import { Breakpoint, Color, ZIndex } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { hexToRgba } from '../../utils';
import { Image } from '../image/image.component';

import { DotProps } from './photosSlider.types';

export const Container: StyledComponent<'div'> = styled.div`
  max-width: 740px;
  width: 100%;
  height: 780px;
  display: flex;
  position: relative;

  @media ${Breakpoint.Tablet} {
    height: 676px;
  }

  @media ${Breakpoint.Mobile} {
    max-width: 100%;
    height: 930px;
  }

  @media ${Breakpoint.SmallMobile} {
    height: 448px;
  }
`;

export const DotsContainer: StyledComponent<'div'> = styled.div`
  width: 130px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  @media ${Breakpoint.Tablet} {
    display: none;
  }

  @media ${Breakpoint.Mobile} {
    display: flex;
    flex-direction: row;
    position: absolute;
    z-index: ${ZIndex.Min};
    width: 100%;
    height: auto;
    bottom: 24px;
  }
`;

export const Dot: StyledComponent<'button', DotProps> = styled.button.attrs<DotProps>({ type: 'button' })`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  transition: 0.2s;
  flex-shrink: 0;
  background-color: ${({ $isActive }: DotProps): string => $isActive ? Color.Black : hexToRgba(Color.Black, 0.2)};
  margin: 8px 0;

  @media ${Breakpoint.Mobile} {
    background-color: ${({ $isActive }: DotProps): string => $isActive ? Color.White : hexToRgba(Color.Black, 0.2)};
    margin: 0 8px;
  }
`;

export const SwiperWrapper: StyledComponent<'div'> = styled.div`
  position: relative;
  width: inherit;
  height: inherit;
  display: flex;
`;

export const SwiperContainer: StyledComponent<'div'> = styled.div`
  width: 610px;
  height: 100%;

  @media ${Breakpoint.SmallDesktop} {
    max-width: 610px;
    width: 100%;
  }

  @media ${Breakpoint.Tablet} {
    max-width: 528px;
  }

  @media ${Breakpoint.Mobile} {
    max-width: 100%;
  }
`;

export const ImageElement: StyledComponent<typeof Image> = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
`;

export const FullSizePopupContainer: StyledComponent<'div'> = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: ${Color.White};
  z-index: ${ZIndex.PhotosSliderFullSize};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FullSizeImage: StyledComponent<typeof Image> = styled(Image)`
  height: 100%;
  width: 100%;
  object-fit: contain;
`;

export const FullSizeButtonsContainer: StyledComponent<'div'> = styled.div`
  width: 100%;
  position: absolute;
  bottom: 40px;
  display: flex;
  justify-content: center;
  z-index: ${ZIndex.PhotosSliderFullSizeButtons};

  @media ${Breakpoint.SmallMobile} {
    width: auto;
    top: 20px;
    right: 20px;
  }
`;

export const FullSizeButton: StyledComponent<'button'> = styled.button`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  margin: 0 20px;
  background-color: ${Color.White};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: 0.2s;

  @media ${Breakpoint.SmallMobile} {
    margin: 0;
  }
`;
